import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';
import { Button } from '@/components/ui/button';

const TermsAndConditions = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-gradient-to-br from-slate-50 via-blue-50/30 to-slate-50">
      <nav className="backdrop-blur-xl bg-white/80 border-b border-slate-200/50 px-4 sm:px-6 py-3 sm:py-4 sticky top-0 z-50">
        <div className="max-w-4xl mx-auto flex items-center gap-4">
          <Button
            variant="ghost"
            size="sm"
            onClick={() => navigate(-1)}
            className="gap-2"
          >
            <ArrowLeft className="w-4 h-4" />
            Indietro
          </Button>
          <h1 className="text-lg sm:text-xl font-bold text-slate-900">Termini e Condizioni</h1>
        </div>
      </nav>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 py-8 sm:py-12">
        <div className="bg-white rounded-2xl shadow-xl p-6 sm:p-10">
          <div className="prose prose-slate max-w-none">
            <p className="text-sm text-slate-600 mb-6">Ultimo aggiornamento: {new Date().toLocaleDateString('it-IT')}</p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4">1. Accettazione dei Termini</h2>
            <p className="mb-4">
              Utilizzando la piattaforma traveldiscount.ai (il "Servizio"), gestita da <strong>Facile Digitale Srls</strong> 
              (P.IVA: [Da completare]), accetti di essere vincolato da questi Termini e Condizioni.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4 mt-8">2. Descrizione del Servizio</h2>
            <p className="mb-4">
              traveldiscount.ai è un marketplace bidirezionale che connette viaggiatori e proprietari di strutture ricettive. 
              Il servizio permette:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Ai viaggiatori di cercare offerte last-minute e creare richieste di soggiorno con budget range</li>
              <li>Ai proprietari di pubblicare offerte e ricevere richieste dai viaggiatori</li>
              <li>Sistema di offerte e contro-offerte per negoziare prezzi</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 mb-4 mt-8">3. Registrazione e Account</h2>
            <p className="mb-4">
              Per utilizzare il Servizio, devi:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Avere almeno 18 anni</li>
              <li>Fornire informazioni accurate e complete durante la registrazione</li>
              <li>Mantenere la sicurezza del tuo account e password</li>
              <li>Notificare immediatamente Facile Digitale Srls di qualsiasi uso non autorizzato</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 mb-4 mt-8">4. Obblighi degli Utenti</h2>
            
            <h3 className="text-xl font-semibold text-slate-800 mb-3 mt-6">4.1 Viaggiatori</h3>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Fornire informazioni veritiere nelle richieste di soggiorno</li>
              <li>Rispettare le strutture ricettive e le loro proprietà</li>
              <li>Pagare gli importi concordati nei tempi stabiliti</li>
            </ul>

            <h3 className="text-xl font-semibold text-slate-800 mb-3 mt-6">4.2 Proprietari</h3>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>Fornire descrizioni accurate delle proprietà</li>
              <li>Rispettare gli accordi e i prezzi concordati</li>
              <li>Mantenere gli standard di qualità dichiarati</li>
              <li>Essere in possesso di tutte le autorizzazioni legali necessarie</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 mb-4 mt-8">5. Commissioni e Pagamenti</h2>
            <p className="mb-4">
              Facile Digitale Srls applica una commissione del 20% su ogni transazione completata. 
              I dettagli specifici delle commissioni saranno comunicati prima della conferma di ogni prenotazione.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4 mt-8">6. Cancellazioni e Rimborsi</h2>
            <p className="mb-4">
              Le politiche di cancellazione e rimborso sono stabilite da ogni singolo proprietario e 
              comunicate al momento della prenotazione. Facile Digitale Srls non è responsabile delle 
              politiche di cancellazione dei singoli proprietari.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4 mt-8">7. Limitazione di Responsabilità</h2>
            <p className="mb-4">
              Facile Digitale Srls agisce come intermediario tra viaggiatori e proprietari. Non siamo 
              responsabili per:
            </p>
            <ul className="list-disc pl-6 mb-4 space-y-2">
              <li>La qualità, sicurezza o legalità delle proprietà pubblicate</li>
              <li>L'accuratezza delle descrizioni fornite dai proprietari</li>
              <li>La capacità o volontà dei viaggiatori di completare le prenotazioni</li>
              <li>Eventuali danni, perdite o lesioni subite durante il soggiorno</li>
            </ul>

            <h2 className="text-2xl font-bold text-slate-900 mb-4 mt-8">8. Contenuti Utente</h2>
            <p className="mb-4">
              Gli utenti sono responsabili dei contenuti che pubblicano sul Servizio. Concedi a 
              Facile Digitale Srls una licenza mondiale, non esclusiva e gratuita per utilizzare, 
              modificare e visualizzare tali contenuti nell'ambito del Servizio.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4 mt-8">9. Risoluzione delle Controversie</h2>
            <p className="mb-4">
              Qualsiasi controversia derivante da questi Termini sarà soggetta alla giurisdizione 
              esclusiva dei tribunali italiani, secondo la legge italiana.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4 mt-8">10. Modifiche ai Termini</h2>
            <p className="mb-4">
              Facile Digitale Srls si riserva il diritto di modificare questi Termini in qualsiasi momento. 
              Le modifiche saranno efficaci immediatamente dopo la pubblicazione. L'uso continuato del 
              Servizio dopo le modifiche costituisce accettazione dei nuovi Termini.
            </p>

            <h2 className="text-2xl font-bold text-slate-900 mb-4 mt-8">11. Contatti</h2>
            <p className="mb-4">
              Per domande su questi Termini, contattaci:
            </p>
            <div className="bg-slate-50 p-4 rounded-lg">
              <p className="font-semibold">Facile Digitale Srls</p>
              <p>Email: info@faciledigitale.it</p>
              <p>P.IVA: [Da completare]</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsAndConditions;
